import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import useStockStore from '../../store'
import { defer } from 'react-router-dom'
import { DEFAULT_ORDER_STOCK_UNTIL } from './constants'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Stock On Hand loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Stock On Hand loader')

  useStockStore.getState().resetPredictedOrderSlice()

  // Populating the stock take templates dropdown before the page  loads
  const getStocktakeTemplates = useStockStore
    .getState()
    .getStocktakeTemplates(false)

  const getItems = useStockStore.getState().getItems()

  const getStockUnits = useStockStore.getState().getStockUnits()

  const updatePredictedOrderBudget = useStockStore
    .getState()
    .updatePredictedOrderBudget(DEFAULT_ORDER_STOCK_UNTIL())

  const getUnits = useStockStore.getState().getStockUnits()

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({
    data: Promise.all([
      getStocktakeTemplates,
      getItems,
      getStockUnits,
      updatePredictedOrderBudget,
      getUnits,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Invoices Promise.all error', error)
        return false
      }),
  })
}
